import { VideoJsPlayer } from 'video.js'

type MuxPluginProps = { data: any; debug: boolean }

declare global {
    interface Window {
        THEOplayer: any
        initTHEOplayerMux: any
    }
}
export interface Mux {
    (_: MuxPluginProps): any
    emit: (event: string, data: any) => any
}

export interface VideoPlayerReloadOptions {
    errorInterval?: number
    getSource?: () => string
}

export interface VideoPlayerWithPlugins extends VideoJsPlayer {
    activePlugins_: any
    airPlay: () => any
    mux: Mux
    chromecast: (_: { receiverAppID: any; buttonPositionIndex: number; addButtonToControlBar: boolean }) => any
    reloadSourceOnError: (options: VideoPlayerReloadOptions) => void
}

//Video player states
export enum PlayerStates {
    PRE_SHOW_W_PRE_ROLL = 'preShowWithPreRoll',
    PRE_SHOW_NO_ACCESS = 'preShowNoAccess',
    PRE_SHOW_W_ACCESS = 'preShowWithAccess',
    LIVE = 'live',
    LIVE_NO_ACCESS = 'liveWithPaywall',
    SOLD_OUT = 'soldOut',
    SHOW_ENDED = 'showEnded',
    LOADING = 'loading',
}
